/**
 * Forward analytics events to native Firebase (iOS / Android WebView).
 *
 * Important: payloads must stay flat property-list types for WKWebView
 * postMessage (no nested objects). Nested `params` previously crashed iOS.
 */

function isNativeApp () {
  try {
    return !!(navigator && navigator.userAgent &&
      (navigator.userAgent.indexOf('TEAMTIP') > 0 || navigator.userAgent.indexOf('Teamtip') > 0))
  } catch (e) {
    return false
  }
}

function sanitizeEventName (name) {
  var eventName = String(name).replace(/[^A-Za-z0-9_]/g, '_').slice(0, 40)
  if (!/^[A-Za-z]/.test(eventName)) {
    eventName = ('E_' + eventName).slice(0, 40)
  }
  return eventName
}

function sanitizeParamValue (value) {
  if (value === null || value === undefined) {
    return null
  }
  if (typeof value === 'boolean') {
    return value ? 'true' : 'false'
  }
  if (typeof value === 'number') {
    if (!isFinite(value)) {
      return null
    }
    return value
  }
  if (typeof value === 'string') {
    return value.slice(0, 100)
  }
  try {
    return String(value).slice(0, 100)
  } catch (e) {
    return null
  }
}

var RESERVED = { type: 1, command: 1, name: 1 }

/**
 * Build a flat dict: { type, command:'event', name, ...string/number params }
 */
function buildEventPayload (name, params) {
  var payload = {
    type: 'firebaseLogEvent',
    command: 'event',
    name: sanitizeEventName(name)
  }
  if (!params || typeof params !== 'object') {
    return payload
  }
  var keys = Object.keys(params)
  var count = 0
  for (var i = 0; i < keys.length && count < 25; i++) {
    var key = String(keys[i]).replace(/[^A-Za-z0-9_]/g, '_').slice(0, 40)
    if (!key || RESERVED[key]) {
      continue
    }
    var value = sanitizeParamValue(params[keys[i]])
    if (value === null) {
      continue
    }
    payload[key] = value
    count++
  }
  return payload
}

function postEventPayload (payload) {
  try {
    if (window.webkit && window.webkit.messageHandlers &&
        window.webkit.messageHandlers.TeamtipAppInterface) {
      // Flat object only — same shape as working page_view bridge
      window.webkit.messageHandlers.TeamtipAppInterface.postMessage(payload)
    }
  } catch (err) {
  }
  try {
    if (window.TeamtipAppInterface &&
        typeof window.TeamtipAppInterface.firebaseLogEvent === 'function') {
      window.TeamtipAppInterface.firebaseLogEvent(JSON.stringify(payload))
    }
  } catch (err) {
  }
}

export function logNativeFirebaseEvent (name, params) {
  try {
    if (!isNativeApp() || !name) {
      return
    }
    postEventPayload(buildEventPayload(name, params))
  } catch (e) {
  }
}

/**
 * On native WebView only: send $gtag.event to Firebase via the bridge.
 * Does not call the original gtag path (bootstrap:false / no gtag.js in app).
 */
export function wrapGtagEventForNative (gtagApi) {
  try {
    if (!isNativeApp() || !gtagApi || typeof gtagApi.event !== 'function') {
      return
    }
    var originalEvent = gtagApi.event
    gtagApi.event = function (name, params) {
      try {
        logNativeFirebaseEvent(name, params)
      } catch (e) {
      }
      // Intentionally do not call originalEvent in the native app —
      // vue-gtag's query('event', ...) is unreliable without gtag bootstrap
      // and was a likely source of WebView failures.
      return undefined
    }
    // Keep a reference in case something needs it later
    gtagApi._teamtipOriginalEvent = originalEvent
  } catch (e) {
  }
}
